import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="mt-12 bg-black/30 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
          <div>
            <h4 className="text-white font-semibold mb-2">Contato</h4>
            <p className="text-purple-200">Email: contato@astralyz.com.br</p>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-2">Legal</h4>
            <div className="flex flex-col space-y-1 text-purple-200">
              <Link to="/termos-de-uso" className="hover:text-white">Termos de Uso</Link>
              <Link to="/politica-de-privacidade" className="hover:text-white">Política de Privacidade</Link>
              <Link to="/sobre-aurora" className="hover:text-white">Sobre a Aurora Lyz</Link>
            </div>
          </div>
          <div className="md:text-right">
            <h4 className="text-white font-semibold mb-2">Astralyz</h4>
            <p className="text-purple-200">Tarot & Astrologia com IA</p>
          </div>
        </div>
        <div className="mt-6 text-center text-xs text-purple-300">
          © {new Date().getFullYear()} Astralyz. Todos os direitos reservados.
        </div>
      </div>
    </footer>
  );
};

export default Footer;